import { useTheme } from '@mui/material';

export const InfoIcon = () => {
    const theme = useTheme();
    const stroke = theme.colors.palette.secondary.main;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M2.59993 11.225C2.79423 12.3902 3.26103 13.4931 3.9623 14.4437C4.66357 15.3944 5.57949 16.1659 6.63544 16.6955C7.69139 17.2251 8.85751 17.4978 10.0388 17.4913C11.2201 17.4849 12.3832 17.1994 13.4333 16.6583L16.2583 17.2417C16.3933 17.2693 16.533 17.2629 16.6649 17.2233C16.7969 17.1836 16.917 17.1119 17.0144 17.0145C17.1118 16.917 17.1836 16.797 17.2232 16.665C17.2629 16.5331 17.2692 16.3933 17.2416 16.2583L16.6666 13.425C17.21 12.3692 17.4949 11.1995 17.498 10.0121C17.5011 8.82475 17.2222 7.6536 16.6842 6.59504C16.1463 5.53649 15.3647 4.62078 14.4038 3.92326C13.4429 3.22574 12.3301 2.76635 11.1569 2.58287C9.98378 2.3994 8.78385 2.49708 7.65584 2.8679C6.52782 3.23871 5.50398 3.87205 4.66853 4.71581C3.83308 5.55957 3.20991 6.58964 2.85028 7.72127C2.49065 8.8529 2.40485 10.0537 2.59993 11.225Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0442 6.66656H9.96088M9.99994 13.3331V10.8331"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
